import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DownloadTradesPostRequestModel } from "@/features/accounts/shared/services/download-trades-model";

export type DownloadExcelJobStatus = 0 | 1 | 2 | 3;

export interface DownloadExcelJobStartResponseModel {
  download_job_id?: string;
  status?: DownloadExcelJobStatus;
  message?: string;
}

export interface DownloadExcelJobStatusResponseModel {
  download_job_id: string;
  status: DownloadExcelJobStatus;
  file_name?: string;
  file_size?: number;
}

export class DownloadTradesApi {
  /**
   * Excel出力API
   */
  public downloadTrades = async (
    param: DownloadTradesPostRequestModel
  ): Promise<Blob> => {
    const path = `/api/downloadexcel`;
    const res = await ApiClient.instance.postBlob<Blob>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };

  /**
   * グループ単位Excel作成の開始API。
   * passbook_info は既存APIと同じJSON配列文字列のままserverへ渡す。
   */
  public startDownloadExcelJob = async (
    param: DownloadTradesPostRequestModel
  ): Promise<DownloadExcelJobStartResponseModel> => {
    const path = "/api/downloadexcel/jobs";
    const request = {
      account_group_id: param.account_group_id,
      file_name: param.file_name,
      passbook_info: param.passbook_info,
    };
    const res = await ApiClient.instance.post<DownloadExcelJobStartResponseModel>({
      path: path,
      params: request,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };

  /**
   * Job状態確認API。
   * モーダル表示中にポーリングし、完了後に成果物APIを呼び出す。
   */
  public getDownloadExcelJobStatus = async (
    downloadJobId: string
  ): Promise<DownloadExcelJobStatusResponseModel> => {
    const path = `/api/downloadexcel/jobs/${downloadJobId}`;
    const res = await ApiClient.instance.get<DownloadExcelJobStatusResponseModel>({
      path: path,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };

  /**
   * 完了済み成果物のBlob取得API。
   * server側は送信処理に入った後、EFSファイル削除を試行する。
   */
  public downloadExcelJobFile = async (downloadJobId: string): Promise<Blob> => {
    const path = `/api/downloadexcel/jobs/${downloadJobId}/download`;
    const res = await ApiClient.instance.getBlob<Blob>({
      path: path,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
